import React from 'react';
import { styled } from '@linaria/react';
import { Flex } from '@daedalus/atlas/helpers/Flex';
import { Icon } from '@daedalus/atlas/Icon';
const _exp = /*#__PURE__*/() => Flex.Row;
const LocationWrapper = /*#__PURE__*/styled(_exp())({
  name: "LocationWrapper",
  class: "lolkh6n",
  propsAsIs: true
});
const NameWrapper = /*#__PURE__*/styled('div')({
  name: "NameWrapper",
  class: "nh9mayo",
  propsAsIs: false
});
interface Props {
  place: string;
  hotelId: string;
}
export const Location = ({
  place,
  hotelId
}: Props) => {
  return <LocationWrapper alignItems="flex-start" justifyContent="flex-start">
      <Icon name="Pin" size="sm" />
      <NameWrapper id={`HotelCardMobileLocation-${hotelId}`} data-id="HotelCardLocation">
        {place}
      </NameWrapper>
    </LocationWrapper>;
};

require("./Location.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./Location.tsx");